import * as React from 'react';

import { IconPen } from './icons/icons_pen';
import { trackOpenCommentsBlock } from './tracking';

export interface ICommentsButtonProps {
  commentText: string;
  isOpen: boolean;
}

export interface ICommentsButtonDispatch {
  changeEdditing(editings: boolean): void;
  closeComments(): void;
  openComments(): void;
}

export type IProps = ICommentsButtonProps & ICommentsButtonDispatch;

import * as styles from './index.css';

export class CommentsButton extends React.Component<IProps, {}> {
  public componentDidMount() {
    if (this.props.commentText.length > 0) {
      this.props.openComments();
    }
  }

  public render() {
    return (
      <div className={styles['button']} onClick={this.handleClick} title="Комментарий">
        <IconPen />
      </div>
    );
  }

  private handleClick = () => {
    const { commentText, changeEdditing, closeComments, openComments, isOpen } = this.props;

    if (isOpen && commentText) {
      return;
    }

    if (!isOpen) {
      trackOpenCommentsBlock();
      changeEdditing(true);
      openComments();
    }

    if (isOpen || (isOpen && !commentText)) {
      closeComments();
    }
  };
}
